import {
  LIST_CAREGIVERS_RESULT,
  LIST_CAREGIVERS,
  CLEAR_ENTITIES,
  LIST_CAREGIVERS_ERROR,
} from '../actions/action-types';

const patientCaregiversReducer = (state = { patientCaregivers: {} }, action) => {
  switch (action.type) {
    case LIST_CAREGIVERS:
      return {
        ...state,
        loading: true,
        preparing: true,
      };
    case LIST_CAREGIVERS_RESULT:
      return {
        ...state,
        patientCaregivers: action.response,
        loading: false,
        preparing: false,
      };
    case LIST_CAREGIVERS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_ENTITIES:
      if (action.entities && action.entities.indexOf('patientCaregivers') !== -1) {
        return {
          ...state,
          patientCaregivers: {},
          preparing: true,
          loading: true,
        };
      }
      return state;
    default:
      return state;
  }
};

export default patientCaregiversReducer;
